<template>
    <div>
        <div class="menu">
            <router-link class="activity" :to="{name: 'activities'}">
                <div class="button">
                    <img src="@/assets/img/sidebar/activity.svg">
                    活動專區
                </div>
            </router-link>
            <router-link class="item" :to="{name: 'orders'}">
                <div class="icon">
                    <img src="@/assets/img/sidebar/list.svg">
                </div>
                <div class="title">
                    我的任務
                </div>
            </router-link>
            <router-link class="item" :to="{name: 'notices'}">
                <div class="icon">
                    <img src="@/assets/img/bell.svg">
                    <div v-show="unreadCount" class="number">{{ unreadCount }}</div>
                </div>
                <div class="title">
                    推播通知
                </div>
            </router-link>
            <router-link class="item" :to="{name: 'profile'}">
                <div class="icon">
                    <img src="@/assets/img/sidebar/person.svg">
                </div>
                <div class="title">
                    個人資訊
                </div>
            </router-link>
            <router-link class="item" :to="{name: 'agreements'}">
                <div class="icon">
                    <img src="@/assets/img/sidebar/card.svg">
                </div>
                <div class="title">
                    支付設定
                </div>
            </router-link>
            <router-link class="item" :to="{name: 'coupons'}">
                <div class="icon">
                    <img src="@/assets/img/sidebar/offer.svg">
                </div>
                <div class="title">
                    我的優惠
                </div>
            </router-link>
            <a href="https://paopaotui.com.tw/QA.html" target="_blank" class="item">
                <div class="icon">
                    <img src="@/assets/img/sidebar/Q&A.svg">
                </div>
                <div class="title">
                    常見問題
                </div>
            </a>
            <div class="item">
                <div class="icon">
                    <img src="@/assets/img/sidebar/chat.svg">
                </div>
                <div class="title">
                    <a target="_blank" href="https://line.me/R/ti/p/%40hjc7084c">聯絡客服</a>
                </div>
            </div>
            <router-link class="item" :to="{name: 'recommend'}">
                <div class="icon">
                    <img src="@/assets/img/sidebar/gift.svg">
                </div>
                <div class="title">
                    推薦領好禮
                </div>
            </router-link>
        </div>
        <div class="footer" v-show="isLogin" @click="logoutBrn">
            登出
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    export default {
        name: 'Sidebar',
        computed: {
            ...mapGetters(['isLogin', 'unreadCount']),
        },
        methods: {
            logoutBrn() {
                this.logout();
                this.$router.push({
                    name: 'login'
                })
            },
            ...mapActions(['logout'])
        }
    };
</script>

<style lang="scss" scoped>
    .menu {
        padding-top: 45px;
    }

    .footer {
        height: 25px;
        color: rgba(155,155,155,1);
        font-size: 18px;
        line-height: 25px;
        text-align: left;
        bottom: 0;
        position: absolute;
        margin: 0 0 30px 40px;
    }

    .item {
        display: flex;
        align-items: center;
        padding: 10px;
        padding-left: 40px;
    }

    .activity {
        display: flex;
        .button {
            flex-shrink: 0;
            background-color: #4a4a4a;
            display: flex;
            padding: 5px 25px;
            color: #FFFFFF;
            font-size: 18px;
            border-radius: 26px;
            margin-left: 30px;
            margin-bottom: 45px;
            cursor: pointer;
            user-select: none;

            img {
                margin-right: 5px;
            }
        }
    }

    .icon {
        position: relative;
    }

    .icon {
        img {
            width: 30px;
            height: 30px;
        }

        .number {
            position: absolute;
            top: 0;
            right: -4px;
            line-height: 16px;
            font-size: 10px;
            width: 16px;
            height: 16px;
            border-radius: 90px;
            background-color: #F44336;
            color: #ffffff;
            font-weight: 500;
            text-align: center !important;
        }
    }

    .title {
        height: 30px;
        color: rgba(0,0,0,1);
        font-size: 18px;
        line-height: 25px;
        text-align: right;
        padding-left: 15px;
    }

    a {
        color: rgba(0,0,0,1);
        font-size: 18px;
        line-height: 25px;
        text-align: right;
        text-decoration: none;
    }
</style>
